import { Bold, P1 } from '@/components/typography'
import { CustomerLabels } from '@/interfaces/customer'

const SingleLabel = ({ label, value }: { label: string; value: string }) => (
  <>
    <P1>
      <Bold>{label}</Bold>
    </P1>
    <P1 className="mb-6">{value}</P1>
  </>
)
const CustomerLabelsList = ({
  customerLabels,
}: {
  customerLabels: CustomerLabels
}) => (
  <div className="col-span-full hidden md:block lg:col-start-1 lg:col-end-5">
    <SingleLabel
      label="Branche"
      value={customerLabels.industry?.value ?? '_'}
    />
    <SingleLabel
      label="Aantal medewerkers"
      value={customerLabels.organisationSize?.value ?? '_'}
    />
    <SingleLabel
      label="Hoofdkantoor"
      value={customerLabels.headquarter ?? '_'}
    />
  </div>
)

export default CustomerLabelsList
